import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { translate } from 'i18n/jhipster-language';
import PCol from 'shared/ui/pcol';
import React, { memo } from 'react';
const OutPutPair = memo(({ label, value, labelMd = '2', valueMd = '4', className, valueClassName, children, translation = true, }) => {
    const labelText = translation ? translate(label) : label;
    const hasValue = value != null && String(value).trim() !== '';
    const valueText = hasValue ? String(value) : '—';
    return (_jsxs(_Fragment, { children: [_jsx(PCol, { col: 12, md: labelMd, className: `cms-output-pair__label-col ${className ?? ''}`.trim(), children: _jsx("div", { className: "cms-output-pair__label", children: labelText }) }), _jsx(PCol, { col: 12, md: valueMd, className: `cms-output-pair__value-col ${valueClassName ?? ''}`.trim(), children: _jsx("div", { className: [
                        'cms-output-pair__value',
                        children ? 'cms-output-pair__value--custom' : '',
                        !children && !hasValue ? 'cms-output-pair__value--empty' : '',
                    ]
                        .filter(Boolean)
                        .join(' '), children: children ?? valueText }) })] }));
});
OutPutPair.displayName = 'OutPutPair';
export default OutPutPair;
